import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from "react-router-dom";
import EventDesc from './EventDesc';
import Footer from './Footer';

export function EndPage(props) {

    let { eventCode } = useParams();
    const [noEvent, setNoEvent] = useState(false);
    const [eventDetail, setEventDetail] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        var selectedEvent = props.eventDetails.find(d => Object.keys(d)[0] === eventCode);
        if (selectedEvent) {
            setEventDetail(selectedEvent[eventCode]);
        } else {
            setNoEvent(true);
        }
    }, [props.eventDetails, eventCode]);

    return (
        <div>
            <div className="text-center justify-content-center border-bottom padding-15">
                <div>
                    <h2>The Ballot Registration is closed.</h2>
                    <h2>抽籤活動現已完結</h2>
                </div>
            </div>
            <EventDesc {...eventDetail} hide={true} />
            <Footer />
            {
                noEvent && <Redirect to={'/'} />
            }
        </div>
    );
}
